import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Checkbox, Col, Form, Input, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const SponsorsFormList = ({ inputFields, setInputFields, data }) => {
  const { t } = useTranslation();

  const handleFormChange = (index, eventName, eventValue) => {
    const data = [...inputFields];
    data[index][eventName] = eventValue;
    setInputFields(data);
  };

  const addFields = () => {
    const newField = {
      name: "",
      logo: null,
      active: false,
    };
    setInputFields([...inputFields, newField]);
  };

  const removeFields = async (index) => {
    const data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };

  return (
    <Form.List name="sponsorsForm" initialValue={inputFields}>
      {(fields, { add, remove }) => {
        return fields.map((field, index) => (
          <React.Fragment key={field.key}>
            <Card
              title={t("dashboard.landingPageSettings.sponsorsSection.cardTitle") + (index + 1)}
              extra={
                "id" in inputFields[index] ? null : (
                  <DeleteFilled
                    onClick={() => {
                      removeFields(index);
                      remove(field.name);
                    }}
                  />
                )
              }
              className={index === fields.length - 1 ? "mb-4" : "mb-5"}
            >
              <Row gutter={[8, 8]}>
                <Col xs={24} lg={12}>
                  <Form.Item
                    label={t("dashboard.landingPageSettings.sponsorsSection.name")}
                    name={[index, "name"]}
                    rules={[
                      {
                        required: true,
                        message: t("requestForm.requiredFieldMessage"),
                      },
                    ]}
                  >
                    <Input
                      maxLength={50}
                      showCount
                      onChange={(event) => handleFormChange(index, "name", event.target.value)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} lg={12}>
                  <Form.Item
                    label={
                      <>
                        {t("dashboard.landingPageSettings.sponsorsSection.logo")}
                        {"id" in inputFields[index] && (
                          <>
                            &nbsp;
                            <a href={data[index].logo} target="_blank" rel="noopener noreferrer">
                              ({t("dashboard.landingPageSettings.sponsorsSection.viewCurrentLogo")})
                            </a>
                          </>
                        )}
                      </>
                    }
                    name={[index, "logo"]}
                    rules={[
                      {
                        required: !("id" in inputFields[index]),
                        message: t("auth.signUp.requiredFieldMessage"),
                      },
                    ]}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(event) => handleFormChange(index, "logo", event.target.files[0])}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[8, 8]}>
                <Col xs={24}>
                  <Form.Item
                    label={t("dashboard.landingPageSettings.sponsorsSection.active")}
                    name={[index, "active"]}
                  >
                    <Checkbox
                      checked={inputFields[index].active}
                      onChange={(event) => handleFormChange(index, "active", event.target.checked)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {index === fields.length - 1 && (
              <Row gutter={[8, 8]} justify="center">
                <Col xs={24} className="mb-4">
                  <Button
                    onClick={() => {
                      addFields();
                      add();
                    }}
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                  />
                </Col>
              </Row>
            )}
          </React.Fragment>
        ));
      }}
    </Form.List>
  );
};
export default SponsorsFormList;
